import { Box, styled } from "@mui/material";
import React, { Suspense, useContext, useEffect } from "react";
import { imagesList } from "../../constants";
import { primary, theme } from "../../constants/theme";
import { Context } from "../../context/context";
import { MemoizedHeader } from "../../layouts/header";
import { MemoizedTabHeader } from "../../layouts/tabHeader";
import OperationalCities from "../../modules/Finance/operationalCities";
import MemoizedHomeBenefits from "../../modules/Home/Benefits/benefit";
import DesktopCarousel from "../../modules/Home/DesktopCarousel/DesktopCarousel";
import HomePageFAQs from "../../modules/Home/HomePageFAQs/homePageFAQs";
import ChargingStations from "../../modules/Home/HomePageRevamp/ChargingStations";
import HeaderBanner from "../../modules/Home/HomePageRevamp/HeaderBanner";
import TabHeader from "../../modules/Home/HomePageRevamp/TabHeader";
import MemoizedWhyMoveAhead from "../../modules/Home/WhyMoveAhead/whyMoveAhead";
import MemoizedTestimonials from "../../modules/Lead Capture/Testimonials/testimonial";
import { MemoizedReview } from "../../modules/Review/review";
import { MemoizedVisitStore } from "../../modules/Store/homeBanner";
import { sendAnalytics } from "../../utils/analyticsCommon";
import { imagesWEBP } from "../../constants/webpImages";
import dynamic from "next/dynamic";

const CategoriesLazy = dynamic(
  () => import("../../components/HomePage/Categories"),
  {
    suspense: true,
  }
);

const NewLaunchSectionLazy = dynamic(
  () => import("../../modules/Home/HomePageRevamp/NewLaunchSection"),
  {
    suspense: true,
  }
);

const HomePageVehicleListLazy = dynamic(
  () => import("../../modules/Home/HomePageRevamp/HomePageVehicleCard"),
  {
    suspense: true,
  }
);

const HappyCustomersLazy = dynamic(
  () => import("../../modules/Home/HomePageRevamp/happyCustomers"),
  {
    suspense: true,
  }
);

const LatestModelLazy = dynamic(
  () => import("../../modules/Home/HomePageRevamp/latestModel"),
  {
    suspense: true,
  }
);

const VideoCallSaleLazy = dynamic(
  () => import("../../modules/Home/HomePageRevamp/VideoCallSale"),
  {
    suspense: true,
  }
);

const TCOLazy = dynamic(
  () => import("../../modules/Home/TCO/tco"),
  {
    suspense: true,
  }
);

const MemoizedVisitStoreLazy = dynamic(
  () => import("../../modules/Store/homeBanner").then((mod) => mod.MemoizedVisitStore),
  {
    suspense: true,
  }
);

const TestDriveLazy = dynamic(
  () => import("../../modules/Home/HomePageRevamp/testDrive"),
  {
    suspense: true,
  }
);

const VehicleLoanLazy = dynamic(
  () => import("../../modules/Home/HomePageRevamp/vehicleLoan"),
  {
    suspense: true,
  }
);

const TurnoPromiseComponentLazy = dynamic(
  () => import("../../SDK/FAQ/turnoPromiseComponent"),
  {
    suspense: true,
  }
);

const KnowLedgeCardsLazy = dynamic(
  () => import("../../modules/Home/knowledgeCards/knowledgeCards"),
  {
    suspense: true,
  }
);


const CustomerHomePage = styled(Box)(() => ({
  ".display-mobile-page": {
    display: "none",
  },

  ".display-desktop-page": {
    display: "block",
  },
  ".loader": {
    textAlign: "center",
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "2em",
    color: primary.dark,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
  },

  [theme.breakpoints.down("md")]: {
    ".display-mobile-page": {
      display: "block",
    },

    ".display-desktop-page": {
      display: "none",
    },
  },
}));

const Home = () => {
  const state = useContext(Context);
  useEffect(() => {
    sendAnalytics("screen_viewed", { screen_name: "home screen" }, "en");
    // eslint-disable-next-line
  }, []);

  return (
    <CustomerHomePage>
      <Box sx={{ pt: 0 }}>
        <Box className="display-mobile-page">
          <MemoizedTabHeader />
          <TabHeader />
          <HeaderBanner imageUrl={imagesWEBP?.homePageBanner2MobileNew} />
          <Suspense fallback={<div className="loader">Loading categories…</div>}>
            <CategoriesLazy />
          </Suspense>

          <Suspense fallback={<div className="loader">Loading new launches…</div>}>
            <NewLaunchSectionLazy />
          </Suspense>

          <Suspense fallback={<div className="loader">Loading vehicles…</div>}>
            <HomePageVehicleListLazy />
          </Suspense>

          <Suspense fallback={<div className="loader">Loading happy customers…</div>}>
            <HappyCustomersLazy title="Customers in 10+ Cities Bought From Us" />
          </Suspense>

          <Suspense fallback={<div className="loader">Loading latest models…</div>}>
            <LatestModelLazy />
          </Suspense>

          <Suspense fallback={<div className="loader">Loading video call info…</div>}>
            <VideoCallSaleLazy />
          </Suspense>

          <Suspense fallback={<div className="loader">Loading TCO section…</div>}>
            <TCOLazy />
          </Suspense>

          <Suspense fallback={<div className="loader">Loading visit store…</div>}>
            <MemoizedVisitStoreLazy />
          </Suspense>

          <Suspense fallback={<div className="loader">Loading test drive…</div>}>
            <TestDriveLazy />
          </Suspense>

          <Suspense fallback={<div className="loader">Loading vehicle loan info…</div>}>
            <VehicleLoanLazy />
          </Suspense>

          <Suspense fallback={<div className="loader">Loading Turno Promise…</div>}>
            <TurnoPromiseComponentLazy />
          </Suspense>

          <Suspense fallback={<div className="loader">Loading Knowledge Cards…</div>}>
            <KnowLedgeCardsLazy />
          </Suspense>

          {/* <Carousel /> */}
          {/* <BookEVConsultationForm /> */}
          {/* <HomePageVehicleThumbnail /> */}
          {/* <MemoizedScheduleTestDrive /> */}
          {/* <OperationalCities /> */}
          {/* <RatingsAndReviews /> */}
        </Box>

        {/* {typeof window !== "undefined" && window.innerWidth > 480 && ( */}
        <Box className="display-desktop-page">
          {/* <LazyLoadImage
            alt="Commercial Electric Gadi"
            style={{ width: "100%", minHeight: "560px" }}
            src={
              typeof window !== "undefined" &&
              window.innerWidth > 480 &&
              imagesList.desktopCarouselBanner4
            }
            visibleByDefault={true}
            fetchpriority={"high"}
            onClick={() => {
              sendAnalytics(
                "view_all_vehicles_desktop_carousel_clicked",
                {},
                "en"
              );
              showCityPopup();
            }}
          /> */}
          <MemoizedHeader />
          <DesktopCarousel />
          <MemoizedVisitStore />
          <MemoizedHomeBenefits />
          <MemoizedTestimonials
            title={"Our electric heroes"}
            buttonText={"View Vehicles"}
            name={"Shankar"}
            work={"Water Distributor"}
            description={
              "Rs 70 only per day to operate vehicle, zero maintenance charges"
            }
            thumbnail={imagesList.homeElectricHeroThumbnail}
            videoLink={"https://www.youtube.com/embed/QwBDYIgMnNA"}
            type={"piaggio"}
            page={"home"}
            data=""
          />
          <MemoizedWhyMoveAhead
            style={{ backgroundColor: "yellow", height: "56.25em" }}
          ></MemoizedWhyMoveAhead>
          <OperationalCities
            headerInfo={"India's Most Trusted Electric Auto Marketplace"}
          />
          <MemoizedReview />
        </Box>
        {/* )} */}

        <HomePageFAQs />
      </Box>
    </CustomerHomePage>
  );
};
export const MemoizedHome = React.memo(Home);
